import React, {useState} from 'react';
import ContactUs from '../components/Contactus';
import Sidebar from '../components/Sidebar';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import ScrollToTop from '../components/ScrollToTop';

const ContactusPage = () => { 
  const[isOpen, setIsOpen] = useState(false);

    const toggle = () => {
        setIsOpen(!isOpen)
    };
  return (
    <>
    <ScrollToTop />
    <Sidebar isOpen={isOpen} toggle={toggle} />
    <Navbar toggle={toggle} />
    <ContactUs />
    <Footer />
    </>
  )
}

export default ContactusPage;
